var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verified",
    clipPath: "url(#verified)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0812 12.6152L9.85625 11.3392C9.68125 11.157 9.47708 11.0658 9.24375 11.0658C9.01042 11.0658 8.80625 11.157 8.63125 11.3392C8.45625 11.5215 8.36875 11.738 8.36875 11.9886C8.36875 12.2392 8.45625 12.4557 8.63125 12.638L10.4688 14.5747C10.6437 14.757 10.8479 14.8481 11.0812 14.8481C11.3146 14.8481 11.5187 14.757 11.6937 14.5747L15.4125 10.7013C15.5875 10.519 15.675 10.3025 15.675 10.0519C15.675 9.80127 15.5875 9.58481 15.4125 9.40253C15.2375 9.22025 15.0297 9.12911 14.7891 9.12911C14.5484 9.12911 14.3406 9.22025 14.1656 9.40253L11.0812 12.6152ZM12 21C11.8979 21 11.8031 20.9924 11.7156 20.9772C11.6281 20.962 11.5406 20.9392 11.4531 20.9089C9.48438 20.2253 7.91667 18.9608 6.75 17.1152C5.58333 15.2696 5 13.2835 5 11.157V6.85063C5 6.47089 5.10573 6.12911 5.31719 5.82532C5.52865 5.52152 5.80208 5.30127 6.1375 5.16456L11.3875 3.11392C11.5917 3.03797 11.7958 3 12 3C12.2042 3 12.4083 3.03797 12.6125 3.11392L17.8625 5.16456C18.1979 5.30127 18.4714 5.52152 18.6828 5.82532C18.8943 6.12911 19 6.47089 19 6.85063V11.157C19 13.2835 18.4167 15.2696 17.25 17.1152C16.0833 18.9608 14.5156 20.2253 12.5469 20.9089C12.4594 20.9392 12.3719 20.962 12.2844 20.9772C12.1969 20.9924 12.1021 21 12 21ZM12 19.1772C13.5167 18.676 14.7708 17.6734 15.7625 16.1696C16.7542 14.6658 17.25 12.9949 17.25 11.157V6.85063L12 4.8L6.75 6.85063V11.157C6.75 12.9949 7.24583 14.6658 8.2375 16.1696C9.22917 17.6734 10.4833 18.676 12 19.1772Z",
    fill: "#F8B944"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "verified"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.8f5ecc11dea982ff005cbf26f589ac1a.svg";
export { ForwardRef as ReactComponent };